import React from "react";

import "./LanguageSelector.css";
import { Icon } from "../../Icon/Icon";

export const LanguageSelectorOption = ({ option, isActive, onClick }) => {
  return (
    <div className="LanguageSelectorOption" onClick={onClick}>
      {isActive && (
        <div className="LanguageSelectorOption__isActive">
          <Icon name="bulletTrans" width={20} height={20} />
        </div>
      )}
      <div
        className={
          isActive
            ? "LanguageSelectorOption__text LanguageSelectorOption__text--active"
            : "LanguageSelectorOption__text"
        }
      >
        {option.label}
      </div>
    </div>
  );
};
